import { Box, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { t } from 'i18next';
import Confetti from 'react-confetti';
import { useDispatch } from 'react-redux';
import toast from 'react-hot-toast';
import Bookings from './Bookings';
import StyledButton from '../Common/StyledButton';
import { resetSaveBookingPageUrl } from '../../redux/booking/bookingSlice';
import { toastStyles } from '../../utils/utils';

interface ISuccessBookingSetupProps {
  closeModel: () => void;
  url: string;
}

export const SuccessBookingSetup = ({ closeModel, url }: ISuccessBookingSetupProps) => {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const linkToCopy = `${process.env.REACT_APP_AUTH_SERVICE}/u/${url}`;
  const dispatch = useDispatch();

  const handleDismiss = () => {
    closeModel();
    dispatch(resetSaveBookingPageUrl());
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(linkToCopy);
    toast.success(t('common.copied'), toastStyles.success);
  };

  return (
    <Box
      width="100%"
      height="90vh"
      minWidth="70vw"
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        flexDirection: 'column',
      }}
    >
      <Bookings
        height="100%"
        border={false}
        title={`${t('bookings.setupBookingsSuccess.title')} `}
        description={t('bookings.setupBookingsSuccess.description')}
        icon={<img src="/assets/icons/confetti-red.svg" alt="bookings" />}
        component={
          <Box>
            <Box
              width="100%"
              maxWidth="500px"
              sx={{
                padding: '15px',
                borderRadius: '10px',
                margin: '10px',
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'row',
                background: '#7CAEBE33',
              }}
            >
              <Tooltip
                title={linkToCopy}
                arrow
                componentsProps={{
                  tooltip: {
                    sx: {
                      bgcolor: 'primary.main',
                      borderRadius: '5px',
                      padding: '8px 12px',
                    },
                  },
                }}
              >
                <Typography
                  variant="bodyBold"
                  px={1}
                  color="primary"
                  justifyContent="row-reverse"
                  maxWidth={isMediumScreen ? 300 : 500}
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    direction: 'ltr',
                  }}
                >
                  {linkToCopy}
                </Typography>
              </Tooltip>
              <button
                type="button"
                style={{ background: 'transparent', border: 'none' }}
                onClick={copyToClipboard}
              >
                <img
                  src="/assets/icons/bookings-copy.svg"
                  alt="bookings"
                  style={{ cursor: 'pointer' }}
                />
              </button>
            </Box>
            <Box
              sx={{
                padding: '40px',
                borderRadius: '10px',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <StyledButton onClick={handleDismiss} paddingY={12}>
                {t('common.dismiss')}
              </StyledButton>
            </Box>
          </Box>
        }
        activeStep={-1}
      />
      <Confetti width={window.innerWidth} height={window.innerHeight} recycle={false} />
    </Box>
  );
};

export default SuccessBookingSetup;
